
import React from 'react';
import { VideoContentViewer } from './VideoContentViewer';
import { ErrorContentViewer } from './ErrorContentViewer';

interface TrainingVideoContentViewerProps {
  fileUrl: string | null;
  fileId: string;
  resourceId: string;
  onComplete?: () => void;
  onError?: (error: string) => void;
}

export function TrainingVideoContentViewer({
  fileUrl,
  fileId,
  resourceId,
  onComplete,
  onError
}: TrainingVideoContentViewerProps) {
  if (!fileUrl) {
    const errorMessage = "Video URL is missing. Please contact your administrator.";
    if (onError) {
      onError(errorMessage);
    }
    return <ErrorContentViewer message={errorMessage} onRetry={() => window.location.reload()} />;
  }
  
  return (
    <VideoContentViewer
      fileUrl={fileUrl}
      fileId={fileId}
      resourceId={resourceId}
      onComplete={onComplete}
      onError={onError}
    />
  );
}
